export const textTheme = {
    baseStyle: {
        fontFamily: 'fonts',
    },
}
